import { getRandomString } from "test-utilities/fakeHelpers";
import {
  getBreakdown,
  getCountries,
  getFacetGroups,
} from "shared/test-utilities/fakeHelpers";
import { IBreakdown } from "shared/models/breakdown";
import { IPrepareBreakdownViewData } from "shared/helpers/breakdownViewHelpers";

export const roleOptionLabelKeys = {
  undefined: "undefined",
  any: "any",
  specific: "specific",
  none: "none",
};

export const closingDateKeys = {
  today: "today",
  tomorrow: "tomorrow",
  other: "other",
  closed: "closed",
};

export const breadcrumbsKeys = {
  myAccount: "MyAccount",
  jobsFeed: "JobsFeed",
};

export const viewSuggestionMock = {
  viewSuggestionsActionCancel: getRandomString(),
  viewSuggestionsActionEditSuggestion: getRandomString(),
  viewSuggestionsActionRemove: getRandomString(),
  viewSuggestionsActionSubmit: getRandomString(),
  viewSuggestionsActionSuggest: getRandomString(),
  viewSuggestionsCvOptions: [],
  viewSuggestionsLabelAddComment: getRandomString(),
  viewSuggestionsLabelAgenciesFilter: getRandomString(),
  viewSuggestionsLabelAmendment: getRandomString(),
  viewSuggestionsLabelContractExpiryWarning: getRandomString(),
  viewSuggestionsLabelInResponse: getRandomString(),
  viewSuggestionsLabelLess: getRandomString(),
  viewSuggestionsLabelMore: getRandomString(),
  viewSuggestionsLabelMorePhotos: getRandomString(),
  viewSuggestionsLabelNoClientsMessage: getRandomString(),
  viewSuggestionsLabelNoClientsTitle: getRandomString(),
  viewSuggestionsLabelNoSuggestions: getRandomString(),
  viewSuggestionsLabelPerformerAge: getRandomString(),
  viewSuggestionsLabelRoleClosed: getRandomString(),
  viewSuggestionsLabelSearchPerformer: getRandomString(),
  viewSuggestionsLabelSuggestClients: getRandomString(),
  viewSuggestionsLabelSuggestionsSent: getRandomString(),
  viewSuggestionsTitleAgency: getRandomString(),
  viewSuggestionsTitleClient: getRandomString(),
  viewSuggestionsMembershipTypes: [],
  viewSuggestionsVideoShowreelTooltip: getRandomString(),
  viewSuggestionsVoiceClipsTooltip: getRandomString(),
  viewSuggestionsMembershipExpires: getRandomString(),
  viewSuggestionsLabelSelectedCount: getRandomString(),
  viewSuggestionsLabelClientNudged: getRandomString(),
  viewSuggestionsLabelClientSubmittedThemselves: getRandomString(),
  viewSuggestionsLabelAppearanceFilterLabel: getRandomString(),
  viewSuggestionsLabelAppearancesNoResults: getRandomString(),
  viewSuggestionsLabelAppearancesSearchPlaceholder: getRandomString(),
  locationLabel: getRandomString(),
  searchLocationPlaceholder: getRandomString(),
  viewSuggestionsIsRoleCastButtonText: getRandomString(),
};

export const defaultPageTranslationView = {
  viewProjectOverviewLabel: getRandomString(),
  viewSentOnFormat: getRandomString(),
  viewProductionCompanyLabel: getRandomString(),
  viewRoleAnyHeight: getRandomString(),
  viewMessage: getRandomString(),
  viewRolePlayingAgeFormat: getRandomString(),
  viewProductionDirectorLabel: getRandomString(),
  viewRolesHideLabel: getRandomString(),
  viewRoleHeightLabel: getRandomString(),
  viewProductionContractTypeLabel: getRandomString(),
  viewRoleAnyAppearance: getRandomString(),
  viewRoleAnyGender: getRandomString(),
  viewCastingLocationLabel: getRandomString(),
  viewCastingDirectorLabel: getRandomString(),
  viewRoleContractTypeLabel: getRandomString(),
  viewRoleAppearanceLabel: getRandomString(),
  viewSentByAnonymous: getRandomString(),
  viewRoleContractTypeInfoLabel: getRandomString(),
  viewProductionLocationLabel: getRandomString(),
  viewCastingDetailsSectionLabel: getRandomString(),
  viewSentByFormat: getRandomString(),
  viewRoleAnyAges: getRandomString(),
  viewProductionDetailsSectionLabel: getRandomString(),
  viewRolesLabel: getRandomString(),
  viewRoleDisabilityInfoLabel: getRandomString(),
  viewProductionDatesLabel: getRandomString(),
  viewRoleAttachmentsLabel: getRandomString(),
  viewRoleDisabilityOptions: [
    { TypeId: roleOptionLabelKeys.undefined, Translation: getRandomString() },
    { TypeId: roleOptionLabelKeys.any, Translation: getRandomString() },
    { TypeId: roleOptionLabelKeys.specific, Translation: getRandomString() },
    { TypeId: roleOptionLabelKeys.none, Translation: getRandomString() },
  ],
  viewTermsText: getRandomString(),
  viewProjectSummaryLabel: getRandomString(),
  viewTermsLabel: getRandomString(),
  viewRolePlayingAgeLabel: getRandomString(),
  viewRoleGenderLabel: getRandomString(),
  viewAttachmentsLabel: getRandomString(),
  viewRoleReportConcernButton: getRandomString(),
  viewProductionProducerLabel: getRandomString(),
  viewRoleDisabilityLabel: getRandomString(),
  viewCastingDetailsLabel: getRandomString(),
  hiringPreferenceLabel: getRandomString(),
  localHireIsRequired: getRandomString(),
  localHireDescription: getRandomString(),
  localHireNoPreferences: getRandomString(),
  castingTypeLabel: getRandomString(),
  castingTypeOnline: getRandomString(),
  castingTypeSelfTape: getRandomString(),
  castingTypeInPerson: getRandomString(),
  viewClosingDateLabels: [
    {
      TypeId: closingDateKeys.today,
      Translation: getRandomString(),
    },
    {
      TypeId: closingDateKeys.tomorrow,
      Translation: getRandomString(),
    },
    {
      TypeId: closingDateKeys.other,
      Translation: getRandomString(),
    },
    {
      TypeId: closingDateKeys.closed,
      Translation: getRandomString(),
    },
  ],
};

export const countries = getCountries();
export const contractTypes = getFacetGroups();
export const productionTypes = getFacetGroups();
export const rawBreakdown = getBreakdown();
export const defaultBreakdown: IBreakdown = {
  ...rawBreakdown,
  production: {
    ...rawBreakdown.production,
    typeId: productionTypes[0].facets[0].id,
    contractTypeId: contractTypes[0].facets[0].id,
    countryCode: countries[0].countryCode,
  },
};
export const prepareBreakdownViewData = {
  productionTypes,
  contractTypes,
  countries,
} as IPrepareBreakdownViewData;
